import { gql } from '@apollo/client'

/** 默认选中标签选项片段 */
export const DEFAULT_STYLE_DECORATION_OPTION_FIELDS = gql`
  fragment defaultStyleDecorationOptionFields on GeneralAiArtworkOption {
    key
    name
    type
    category
    choiceKey
  }
`

export const POST_ITEM_FIELDS = gql`
  fragment postItemFields on SquarePostInterface {
    id
    title
    content
    sameCount
    postScope
    publishTime
    visibleType
    coverImage {
      id
      imageUrl
      width: length
      height: width
    }
    imageList {
      id
      imageUrl
      aiArtwork {
        id
        extend {
          competition {
            # 大赛名称
            name
            id
          }
          #大赛排名
          competitionRank
          # 是否参加大赛
          competitionLink
        }
        artwork {
          id
        }
        serviceType
      }
    }
    itemSocialInfo {
      collectsCount
      likesCount
      disLikeCount: putDownCount
      status {
        collected
        liked
        disLiked: putDown
      }
    }
    aiArtworkInfo {
      id
      prompt
      ucPrompt
      modelTheme
      model
      modelCode
      size
      initImageUrl
      multiReferenceImageUrlList
      chatGptOptimize
      serviceType
      styleDecorationOptions {
        key
        name
      }
      styleModelOption {
        key
        name
      }
      characterOptions {
        key
        name
      }
      modelFusionOptions: modelFusion {
        key
        name
        weight
      }
      userTrainedModelOption {
        weight
        trainedModel {
          id
          modelName
          valid
        }
      }
      width: length
      height: width
      hiddenBaseInfo
      creativityDegree
      chinesePrompt
      chinesePromptDd
      pattern
      # 预处理方式
      pretreatmentMethod
      # 预处理图
      pretreatmentImage {
        url
      }
      superType
      prefineInfo {
        strength
        multiple
      }
      samplerModelInfo {
        samplerModelName
      }
      seed
      cfg
      ensd
      clipSkip
      # 合集
      aiCollection {
        id
        opened
      }
      extend {
        originalSquarePost {
          id
          status
        }
      }
      mjParam {
        chaos
        quality
        stylize
        tile
        upbeta
        srefUrls
        sw
        crefUrls
        cw
      }
      instantStyle {
        imageUrl
        controlWeight
        showType
        pulidMode
      }
      modelInfo {
        modelVersion
      }
      cutDiffusion {
        cfgScale1
        cfgScale2
        cutdiffProportion
      }
      flux {
        chaos
        style
      }
    }
  }
`

export const POST_ITEM_FIELDS_FORLIST = gql`
  fragment postItemFieldsForList on SquarePostInterface {
    id
    title
    content
    sameCount
    postScope
    publishTime
    visibleType
    sameCount
    sameCreated
    coverImage {
      id
      imageUrl
      sourceType
      width: length
      height: width
    }
    imageList {
      id
      imageUrl
      aiArtwork {
        serviceType
      }
    }
    itemSocialInfo {
      collectsCount
      likesCount
      status {
        collected
        liked
      }
    }
    aiArtworkInfo {
      id
      prompt
      superType
      chatGptOptimize
    }
  }
`

export const POST_ITEM_USER = gql`
  fragment postItemUser on CopyrightBaseUserInfo {
    uid
    nickname
    avatarUrl
    # 禁言状态
    muzzleStatus
    social {
      followStatus
    }
    userRoleInfo {
      artist
      aiArtist
    }
    companyAuthInfo {
      id
    }
    memberDetail {
      hold
    }
  }
`

export const BASE_USER_FIELDS = gql`
  fragment baseUserFields on CopyrightBaseUserInfo {
    backgroundUrl
    avatarUrl
    nickname
    personalizedSignature
    userType # 机构 ｜ 个人
    userRoleInfo {
      artist
      aiArtist
    }
    base {
      uid
    }
    social {
      fansCount
      followCount
      likesCount
      followStatus
      uid
    }
    memberDetail {
      hold
    }
  }
`

/** 排行榜片段 */
export const AI_CREATOR_RANK_FIELDS = gql`
  fragment aiCreatorRankFields on CopyrightUserNewInfoConnection {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        uid
        base {
          avatarUrl
          backgroundUrl
          settledCreatorDay
          nickname
          uid
          userRoleInfo {
            artist
            aiArtist
          }
          memberDetail {
            hold
          }
        }
        social {
          fansCount
          followCount
          likesCount
          followStatus
          squareCount
        }
        artworkStatistics {
          aiSameStyleCount
          aiPictureCount
          rankChange
        }
      }
    }
  }
`

export const AI_ARTWORK_LIST_FIELDS = gql`
  fragment aiArtworkListFields on AiArtWork {
    artWorkUrl @skip(if: $simplify)
    miniArtWorkUrl
    completeTime @skip(if: $simplify)
    completePercent @skip(if: $simplify)
    queuePercent @skip(if: $simplify)
    expectedSeconds @skip(if: $simplify)
    generateTime @skip(if: $simplify)
    id
    status
    width: length
    height: width
    involveYellow
    extend {
      # 是否上架到市场 已上架
      artworkLink
      # 是否参加大赛 已投稿
      competitionLink
      # 是否发布到广场 已发布
      squarePostLink
      # 是否已返图
      backImagePostId
      # 版权
      copyrightArtwork {
        id
        type
        status
      }
    }
    riskControl {
      status
      reason
    }
    chatGptOptimize
    maskImageUrl
    # 超分辩
    superSizePicInfo {
      artWorkUrl
      integral
      length
      multiple: multipleNew
      status
      width
    }
    # 广场发布需要的字段
    keyOfInitParam @include(if: $plaza)
    prompt @include(if: $plaza)
    ucPrompt @include(if: $plaza)
    model @include(if: $plaza)
    modelCode @include(if: $plaza)
    modelTheme @include(if: $plaza)
    styleDecorationOptions @include(if: $plaza) {
      key
      name
    }
    styleModelOption @include(if: $plaza) {
      key
      name
    }
    characterOptions @include(if: $plaza) {
      key
      name
    }
    modelFusionOptions: modelFusion @include(if: $plaza) {
      key
      name
      weight
    }
    userTrainedModelOption @include(if: $plaza) {
      weight
      trainedModel {
        id
        modelName
        valid
      }
    }
    size @include(if: $plaza)
    initImageUrl @include(if: $plaza)
    multiReferenceImageUrlList @include(if: $plaza)
    pattern
    # 预处理方式
    pretreatmentMethod @include(if: $plaza)
    # 预处理图
    pretreatmentImage @include(if: $plaza) {
      url
    }
    creativityDegree @include(if: $plaza)
    superType @include(if: $plaza)
    prefineInfo @include(if: $plaza) {
      strength
      multiple
    }
    seed @include(if: $plaza)
    cfg @include(if: $plaza)
    ensd
    clipSkip
    samplerModelInfo @include(if: $plaza) {
      samplerModelName
      samplerIndex
      # steps
    }
    serviceStatus # 图片是否被清除（非会员超过1000张会被清理）
    violationRefundStatus # 违规退还状态
    queueType
    failMessage {
      failMessage
    }
    superSizePicInfo {
      artWorkUrl
    }
    anyTextMode
    mjParam @include(if: $plaza) {
      chaos
      quality
      stylize
      tile
      upbeta
      srefUrls
      sw
      crefUrls
      cw
    }
    modelDefaultParam @include(if: $plaza) {
      associatedCreateTags {
        id
      }
    }
    instantStyle @include(if: $plaza) {
      imageUrl
      controlWeight
      showType
      pulidMode
    }
    modelInfo @include(if: $plaza) {
      modelVersion
    }
    cutDiffusion @include(if: $plaza) {
      cfgScale1
      cfgScale2
      cutdiffProportion
    }
    serviceType
    flux @include(if: $plaza) {
      chaos
      style
    }
  }
`

export const AI_MAGIC_FIELDS = gql`
  fragment aiMagicFields on MagicDiceRes {
    cfg @skip(if: $onlyPrompt)
    characterOptions @skip(if: $onlyPrompt) {
      key
      name
    }
    model @skip(if: $onlyPrompt)
    modelCode @skip(if: $onlyPrompt)
    modelFusionOptions @skip(if: $onlyPrompt) {
      name
      key
      weight
    }
    promptChinese
    promptEnglish
    styleDecorationOptions @skip(if: $onlyPrompt) {
      key
      name
      type
    }
  }
`

export const COMIC_COLLECT_FRAGMENT = gql`
  fragment comicCollectFragment on ComicCollect {
    id
    image
    name
    desc
    type
    updateType
    user {
      uid
      nickname
      avatarUrl
    }
    postList {
      id
      title
      updateTime
      itemSocialInfo {
        viewsCount
      }
      coverImage {
        imageUrl
      }
    }
  }
`
/** S 资讯片段 */
export const ARTICLE_ITEM_FIELDS = gql`
  fragment articleItemFields on BaseArticle {
    id
    post {
      # 标题
      title
      # 封面图
      thumbnail
      # 发布时间
      postDate
      # 状态
      postStatus
    }
  }
`
